


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import type * as Index from '../index';
import * as index from '../index';
import type * as Internal from '../internal';
import * as internal from '../internal';
import { Child, ComboBox, ItemPane } from '../part';


const eventNames = {
    delete: 'delete',
};

const translates = {
    checkedValue: {
        label: internal.localized(
            'Value being checked',
            'Проверяемое значение (каз)', // TODO translate
            'Проверяемое значение',
        ),
        newItemLabel: internal.localized(
            'Click to set value being checked',
            'Кликните для добавления проверяемого значения (каз)', // TODO translate
            'Кликните для добавления проверяемого значения',
        ),
    },
    deleteButtonText: internal.localized(
        'Delete this check',
        'Удалить эту проверку (каз)', // TODO translate
        'Удалить эту проверку',
    ),
    head: {
        negative: internal.localized(
            'Checking whether text not matches template',
            'Проверка несоответствия текста шаблону (каз)',
            'Проверка несоответствия текста шаблону',
        ),
        positive: internal.localized(
            'Checking whether text matches template',
            'Проверка соответствия текста шаблону (каз)',
            'Проверка соответствия текста шаблону',
        ),
    },
    typeOfCheck: {
        label: internal.localized(
            'Type of check',
            'Тип проверки (каз)', // TODO translate
            'Тип проверки',
        ),
        items: {
            negative: internal.localized(
                'Text NOT MATCHES template',
                'Текст НЕ СООТВЕТСТВУЕТ шаблону (каз)', // TODO translate
                'Текст НЕ СООТВЕТСТВУЕТ шаблону',
            ),
            positive: internal.localized(
                'Text MATCHES template',
                'Текст СООТВЕТСТВУЕТ шаблону (каз)', // TODO translate
                'Текст СООТВЕТСТВУЕТ шаблону',
            ),
        },
    },
    valueTemplate: {
        label: internal.localized(
            'Value template',
            'Шаблон значения (каз)', // TODO translate
            'Шаблон значения',
        ),
        newItemLabel: internal.localized(
            'Click to set value template',
            'Кликните для добавления шаблона значения (каз)', // TODO translate
            'Кликните для добавления шаблона значения',
        ),
    },
};


@Component({
    components: {
        Child,
        ComboBox,
        ItemPane,
    },
})
export default class Like extends Vue {
    // region Свойства
    @Prop({
        type: Object,
        required: false,
        default: () => null,
    })
    public config!: Index.Config | null;

    @Prop({
        type: Object,
        required: true,
    })
    public value!: Internal.Like;

    @Prop({
        type: Boolean,
        required: true,
    })
    public readonly!: boolean;
    // endregion


    // region Разное
    public index = index;
    public translates = translates;

    public get head(): string {
        if (this.value.negative) {
            return translates.head.negative.toString();
        } else {
            return translates.head.positive.toString();
        }
    }

    public getTypeOfCheckText(negative: boolean): string {
        if (negative) {
            return translates.typeOfCheck.items.negative.toString();
        } else {
            return translates.typeOfCheck.items.positive.toString();
        }
    }

    public onDelete() {
        this.$emit(eventNames.delete);
    }
    // endregion
}
